<div ngSkipHydration>

  <div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
    
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <div>
        <h2 class="h5 m-0 fw-bold text-dark">Módulo de Cotizaciones y Presupuestos</h2>
        <span class="small text-muted font-monospace">JDE Commercial Matrix / Sales Pipeline</span>
      </div>
      <!-- Nace desde el patio, pero dejamos este botón por si el flujo inicia manual -->
      <a class="btn btn-primary btn-sm px-4 fw-bold shadow-sm" routerLink="/recepciones" style="border-radius: 6px;">
        ➕ Cotizar desde Patio (Recepciones)
      </a>
    </div>

    <!-- 🔍 Barra de Búsqueda Reactiva -->
    <div class="card mb-3 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        <div class="input-group input-group-sm">
          <span class="input-group-text bg-white border-end-0">🔍</span>
          <input type="text" class="form-control border-start-0 ps-0 text-uppercase" name="buscarCotizacion"
                 [(ngModel)]="filtroTexto" (input)="filtrarCotizaciones()" 
                 placeholder="Buscar por Folio Comercial, Placas, Unidad, AN8 o Nombre del Cliente...">
        </div>
      </div>
    </div>

    <!-- 📊 Tabla de Presupuestos -->
    <table class="table table-hover table-striped border shadow-sm align-middle">
      <thead class="table-dark">
        <tr>
          <th scope="col" style="width: 130px;">FOLIO COMERCIAL</th>
          <th scope="col" style="width: 110px;">FECHA</th>
          <th scope="col">AN8 - CLIENTE</th>
          <th scope="col">VEHÍCULO / PLACAS</th>
          <th scope="col" class="text-end" style="width: 130px;">TOTAL (CON IVA)</th>
          <th scope="col" style="width: 130px;">FOLIO RECEPCION</th>          
          <th scope="col" class="text-center" style="width: 130px;">ESTATUS SAT / CLIENTE</th>
          <th scope="col" class="text-center" style="width: 150px;">ACCIONES</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of cotizacionesPaginadas">
          <th scope="row" class="font-monospace text-primary fw-bold">{{ c.folioCotizacion }}</th>
          <td class="font-monospace text-secondary">{{ c.fechaCreacion | date:'dd/MM/yyyy' }}</td>
          <td class="text-uppercase fw-semibold text-secondary">
            {{ c.an8Cliente }} - {{ c.nombreCliente }}
          </td>
          <td>
            <span class="text-uppercase fw-semibold text-secondary">{{ c.submarcaVehiculo }}</span>
            <span class="fw-semibold text-uppercase text-dark"> - {{ c.placasVehiculo }}</span>           
          </td>
          <td class="text-end font-monospace fw-bold text-dark px-3">
            {{ c.total | currency:'MXN' }}
          </td>

          <td class="text-uppercase fw-semibold text-secondary">
            REC-{{ c.idRecepcion.toString().padStart(8, '0') }}
          </td>         
          
          <td class="text-center">
            <!-- 🚦 Semáforo de Aprobación Comercial en vivo -->
            <span class="badge font-monospace fw-bold px-2 py-1"
                  [ngClass]="{
                    'bg-warning text-dark': c.estatusAprobacion === 'Pendiente',
                    'bg-success': c.estatusAprobacion === 'Aprobado',
                    'bg-danger': c.estatusAprobacion === 'Rechazado',
                    'bg-info text-dark': c.estatusAprobacion === 'Modificado'
                  }">
              {{ c.estatusAprobacion | uppercase }}
            </span>
          </td>

          <!-- Renglos de Acciones del Workflow Comercial -->
          <td>
            <div class="acciones-workflow-container" style="display: flex; gap: 6px; align-items: center; justify-content: center;">
              
              <!-- Botón Editar Rampa -->
              <button class="btn btn-sm btn-outline-secondary py-1" (click)="abrirEditor(c.id!)" style="font-size: 0.78rem;" title="Editar Renglines">
                ⚙️ Ajustar
              </button>

              <!-- Botón Eliminar Físico (Solo si está pendiente para no romper historial de órdenes ya aprobadas) -->
              <button *ngIf="c.estatusAprobacion === 'Pendiente'" 
                      class="btn btn-sm btn-outline-danger py-1" 
                      (click)="eliminarCotizacion(c.id!)" 
                      style="font-size: 0.78rem;" title="Eliminar Registro">
                🗑️
              </button>

              <!-- Visualizador de flujo encadenado hacia la Orden de Servicio JDE -->
              <span *ngIf="c.estatusAprobacion === 'Aprobado'" class="badge-so-migrated font-monospace" 
                    style="color: #1e3a8a; background-color: #dbeafe; padding: 4px 8px; border-radius: 6px; font-size: 11px; font-weight: bold; border: 1px solid #bfdbfe;">
                ⚙️ SO Generada
              </span>
            </div>
          </td>          
        </tr>
        <tr *ngIf="cotizacionesFiltradas.length === 0">
          <td colspan="7" class="text-center text-muted py-4">No se encontraron presupuestos comerciales activos en este taller.</td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">
      
      <!-- 🧭 BARRA DE PAGINACIÓN INTERACTIVA -->
      <nav aria-label="Navegación de presupuestos comerciales">
        <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
          
          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(1)" style="cursor: pointer;" title="Primera Página">
              ⏮️ Primera
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
              ◀️ Anterior
            </button>
          </li>

          <li class="page-item disabled">
            <span class="page-link bg-light text-dark font-monospace border
                         fw-bold px-3">
              PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
            </span>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
              Siguiente ▶️
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                    (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;" title="Última Página">
              Última ⏭️
            </button>
          </li>

        </ul>
      </nav>

      <!-- 📊 LEYENDAS ESTADÍSTICAS INDEXADAS -->
      <span class="text-muted small text-end">
        Mostrando presupuestos del <strong>{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
        al <strong>{{ Math.min(paginaActual * registrosPorPagina, cotizacionesFiltradas.length) }}</strong> 
        de un total de <strong>{{ cotizacionesFiltradas.length }}</strong> cotizaciones en base de datos.
      </span>

    </div>

  </div>

  <!-- 🧳 Contenedor Global de Toasts Reutilizable -->
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
    <div *ngFor="let toast of toastService.toasts" 
         class="toast show shadow border-0 mb-2" 
         [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
         role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
        <strong class="me-auto d-flex align-items-center gap-2">
          <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
          {{ toast.title }}
        </strong>
        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
      </div>
      <div class="toast-body pt-0" style="font-size: 0.85rem;">
        {{ toast.text }}
      </div>
    </div>
  </div>

</div>

<router-outlet></router-outlet>